import { connect } from "react-redux";
import SlateEditor from "../../../shared/components/SlateEditor/editor";
import { seHasAddProductToDraftOrders, setIsBuyingGuide, setIsNotIncreaseQuantityCartItem, setMessageGuide } from "../../../../store/action/settingPageAction";
import { METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";
import Switch from "../../../shared/components/Button/switch";

const SettingAdvanced = (props) => {
  const {
    settingPage,
    setMessageGuide,
    setIsBuyingGuide,
    seHasAddProductToDraftOrders,
    setIsNotIncreaseQuantityCartItem
  } = props;
  const {
    message_guide,
    is_buying_guide,
    type,
    has_add_product_to_draft_orders,
    is_not_increase_quantity_cart_item
  } = settingPage;

  return (
    <div className="setting-auto-reply-wrapper setting-other">
      <div className="card">
        <div className="card-title mb16">
          <span>
            <div className="svg-next-icon card-title-icon ic-adjust">
            </div>
          </span>
          <span>Cài đặt nâng cao</span>
        </div>
        <div className="config-container">
          {type === METHOD_TYPE.AUTO ?
            <div className="switch-with-input">
              <div className="bottom-line">
                <div className="switch-container">
                  <div className="switch-wrapper d-flex-center">
                    <span>
                      <button type="button" className={`app-switch app-switch-small ${is_buying_guide == 1 ? 'app-switch-checked' : 'app-switch'}`} onClick={() => setIsBuyingGuide(is_buying_guide == 1 ? 0 : 1)}>
                        <span className="app-switch-inner">
                        </span>
                        <div className="app-click-animating-node">
                        </div>
                      </button>
                    </span>
                  </div>
                  <div className="switch-title-container">
                    <div className="switch-title">
                      <div>
                        Hiển thị hướng dẫn đặt hàng trên trang giỏ hàng của khách mua
                      </div>
                      {/* <span className="ml3 mr3 pointer">
                    <div className="svg-next-icon livestream-tooltip-image-icon mb3 icon-help-new" >
                    </div>
                  </span> */}
                    </div>
                    <div className="switch-subtitle">
                      Các thông tin đặt hàng, quy định của cửa hàng,... cần thiết để khách hàng chốt đơn.
                    </div>
                  </div>
                  {/* <div className="reset-default-container">
                <span className="livestream-reset-default-button pointer ic-fb-menudot">
                  <div className="svg-next-icon rotate-left" >
                  </div>
                </span>
              </div> */}
                </div>
                {is_buying_guide == 1 &&
                  <div className="input-container">
                    <div className="input-title">
                      Nội dung hướng dẫn:
                    </div>
                    <div className="input-text input-text-none-scrollbar text-multi input-slate editor">
                      <SlateEditor
                        emoji={true}
                        valueDefault={message_guide}
                        onChange={setMessageGuide}
                        maxLength={300}
                      />
                    </div>
                  </div>
                }
              </div>
              {/* <div className="switch-setting-item-wrapper">
                <div className="item-group display-flex-align-items-center">
                  <div className="switch-box">
                    <Switch isActived={is_not_increase_quantity_cart_item} onClick={() => setIsNotIncreaseQuantityCartItem(is_not_increase_quantity_cart_item == 1 ? 0 : 1)} />
                  </div>
                  <div className="info-container">
                    <div className="card-title font-medium text-sm m-none">Không tăng số lượng khi bình luận mã sản phẩm nhiều lần</div>
                    <span className="card-subtitle text-xs m-none">Khi bật cấu hình, nếu khách hàng bình luận mã sản phẩm nhiều lần thì hệ
                      thống sẽ chỉ hiển thị số lượng là 1 cho sản phẩm đó trong giỏ hàng.</span>
                  </div>
                </div>
              </div> */}
            </div>
            :
            <div className="switch-setting-item-wrapper">
              <div className="item-group display-flex-align-items-center">
                <div className="switch-box">
                  <Switch isActived={has_add_product_to_draft_orders} onClick={() => seHasAddProductToDraftOrders(!has_add_product_to_draft_orders ? 1 : 0)} />
                </div>
                <div className="info-container">
                  <div className="card-title font-medium text-sm m-none">Tự động thêm sản phẩm vào đơn hàng nháp</div>
                  <span className="card-subtitle text-xs m-none">
                    Giúp bạn tiết kiệm thời gian, tránh sai sót khi tạo đơn hàng trong màn hình hội thoại.
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { settingPage } = state;

  return {
    settingPage
  };
};

export default connect(mapStateToProps, {
  setMessageGuide,
  setIsBuyingGuide,
  seHasAddProductToDraftOrders,
  setIsNotIncreaseQuantityCartItem
})(SettingAdvanced);

